module["exports"] = [
  0
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/address/postcode.js
// module id = 1536
// module chunks = 1